/**
 * Pure query-prefix helpers, extracted from hooks/useProductsFilter so that
 * server modules (Fetcher, route handlers) can import them without dragging
 * client-only hook code into the server bundle.
 */
export const queryPrefix = "gg__";

export const removeQueryPrefix = (key: string) => key.replace(queryPrefix, "");
export const hasQueryPrefix = (key: string) => key.startsWith(queryPrefix);
